import { Component } from '@angular/core';
import { AppPermission } from '@app/shared/services/apps/apps.service';

@Component({
  selector: 'sbnb-webready',
  template: `
    <sbnb-apps-detail-page
      vendorCode="webready"
      name="Webready"
      logoTile="/assets/images/apps/webready-logo.png"
      builtBy="Webready"
      builtByLink="https://register.usewebready.com"
      [categories]="['Direct bookings']"
      [permissions]="[AppPermission.propertyListingRead, AppPermission.enrichmentRead, AppPermission.calendarRead]"
      email="support@usewebready.com"
      [beta]="false"
      [helpLink]="{
        href: 'https://register.usewebready.com',
        text: 'Automate your operations with Webready + Hospitable'
      }"
      [helpArticles]="[
        {
          id: '10139324',
          title:
            'How to integrate Hospitable with Webready'
        }
      ]">
      <ng-container description>
        <p>
          Webready is the most advanced, purpose-built website builder for the short-term rental market.
          Its goal is to help property owners and managers get more bookings online through their own, modern, responsive, and search engine optimized website. Webready allows you to create your own professional web presence, exactly the way you want it.
        </p>
      </ng-container>
    </sbnb-apps-detail-page>
  `,
})
export class WebreadyComponent {
  public AppPermission = AppPermission;
}
